import { Box, Button, Flex, Text, TextField } from "@radix-ui/themes";
import { type FormEvent, useState } from "react";
import Alert from "../shared/Alert";

interface SignUpFormProps {
    onSubmit: (data: any) => Promise<void>;
    loading: boolean;
}

function SignUpForm({ onSubmit, loading }: SignUpFormProps) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [submissionError, setSubmissionError] = useState("");

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        // Validate passwords match
        if (password !== confirmPassword) {
            setPasswordError("Passwords do not match");
            return;
        }

        setPasswordError("");
        setSubmissionError("");

        try {
            await onSubmit({
                email,
                password,
            });
        } catch (err: any) {
            setSubmissionError(err.message || "Failed to sign up");
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            {passwordError && <Alert type="error" message={passwordError} onClose={() => setPasswordError("")} />}
            {submissionError && <Alert type="error" message={submissionError} onClose={() => setSubmissionError("")} />}

            <Flex direction="column" gap="4">
                <Box>
                    <Text as="div" size="2" mb="1" weight="bold">
                        Email
                    </Text>
                    <TextField.Root
                        size="3"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="your.email@example.com"
                        autoComplete="username"
                        type="email"
                    />
                </Box>

                <Box>
                    <Text as="div" size="2" mb="1" weight="bold">
                        Password
                    </Text>
                    <TextField.Root
                        size="3"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="Choose a strong password"
                        autoComplete="new-password"
                        minLength={6}
                        type="password"
                    />
                </Box>

                <Box>
                    <Text as="div" size="2" mb="1" weight="bold">
                        Confirm Password
                    </Text>
                    <TextField.Root
                        size="3"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        placeholder="Confirm your password"
                        autoComplete="new-password"
                        minLength={6}
                        type="password"
                    />
                </Box>

                <Button
                    type="submit"
                    size="3"
                    variant="soft"
                    loading={loading}
                    style={{
                        cursor: "pointer",
                    }}
                >
                    {loading ? "Creating account..." : "Create Account"}
                </Button>
            </Flex>
        </form>
    );
}

export default SignUpForm;
